import { PudoTransactionTimerActivityHourDayHeatmapChart, hasChartSeries } from '@frontend/chart/components';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { useInsightHeatmapCellClick } from '../heatmap-cell-summary/use-insight-heatmap-cell-click';
import { InsightCardWidth } from '../insight-card-width';
import { InsightCard } from '../insight-card/insight-card.component';
import { useInsightChartMinHeight } from '../insight-detail-mode.context';
import { InsightId } from '../insight-registry/insight-ids';
import { useLast2WeeksPudoTransactionTimerActivityHourDayHeatmapChart } from './use-last-2-weeks-pudo-transaction-timer-activity-hour-day-heatmap-chart';

export interface Last2WeeksPudoTransactionTimerActivityHourDayHeatmapChartProps {
    accountId: string;
    width?: InsightCardWidth;
}

export const Last2WeeksPudoTransactionTimerActivityHourDayHeatmapChart = ({
    accountId,
    width
}: Last2WeeksPudoTransactionTimerActivityHourDayHeatmapChartProps) => {
    const chartMinHeight = useInsightChartMinHeight(280);
    const { data, isLoading, rangeStart, dayCount } = useLast2WeeksPudoTransactionTimerActivityHourDayHeatmapChart(accountId);
    const title = (
        <FormattedMessage
            id='platform.analytics.insights.last-2-weeks-pudo-transaction-timer-activity-hour-day-heatmap-chart.title'
            description='Title of the PuDo insights heatmap showing combined completed drop-off and pick-up timer volume by hour of day over the last two weeks'
            defaultMessage='Hourly activity heatmap'
        />
    );
    const onCellClick = useInsightHeatmapCellClick({
        accountId,
        chartKey: PudoTransactionTimerActivityHourDayHeatmapChart.definition.key,
        title
    });

    return (
        <InsightCard
            insightId={InsightId.PUDO_ACTIVITY_HOUR_DAY_HEATMAP}
            chartKey={PudoTransactionTimerActivityHourDayHeatmapChart.definition.key}
            width={width}
            title={title}
            subtitle={
                <FormattedMessage
                    id='platform.analytics.insights.last-2-weeks-pudo-transaction-timer-activity-hour-day-heatmap-chart.subtitle-14-days'
                    description='Subtitle on the PuDo hourly activity heatmap indicating the chart covers the last 14 days'
                    defaultMessage='last 14 days'
                />
            }
            isLoading={isLoading}>
            {!hasChartSeries(data) || !data ? (
                <div className='text-foreground-default'>{CommonMessage.ERRORS.NO_DATA_AVAILABLE}</div>
            ) : (
                <div
                    className='w-full min-w-0 overflow-hidden'
                    style={{ height: chartMinHeight }}>
                    <PudoTransactionTimerActivityHourDayHeatmapChart
                        data={data}
                        rangeStart={rangeStart}
                        dayCount={dayCount}
                        minHeight={chartMinHeight}
                        onCellClick={onCellClick}
                    />
                </div>
            )}
        </InsightCard>
    );
};
